import { Company } from "./company/Company";
import { IDisbursement, IDocument, ILoan } from "../resources/interfaces";
import { DISBURSEMENT_STATUS } from "../resources/enums";
import { IActivityStreams } from "../resources/interfaces";

export default class Disbursement {
    id: number;
    reference: string;
    activityStreams: IActivityStreams[];
    name: string;
    description: string;
    financier?: Company;
    recipient?: Company;
    amountToSettle: number;
    amountPaid: number;
    status: DISBURSEMENT_STATUS;
    paidOn: Date;
    paymentReference: string;
    loans: ILoan[];
    channel: string;
    createdOn: Date;
    updatedOn: Date;
    evidenceUrl?: string;


    constructor(data: IDisbursement) {
        this.id = data.id;
        this.reference = data.reference;
        this.name = data.name;
        this.description = data.description;
        this.financier = data.financier ? new Company(data.financier) : undefined;
        this.recipient = data.recipient ? new Company(data.recipient) : undefined;
        this.amountToSettle = data.amountToSettle;
        this.amountPaid = data.amountPaid;
        this.status = data.status;
        this.paidOn = data.paidOn;
        this.paymentReference = data.paymentReference;
        this.loans = data.loans;
        this.channel = data.channel;
        this.createdOn = data.createdOn;
        this.updatedOn = data.updatedOn;
        this.activityStreams = data.activityStreams;
        this.evidenceUrl = data.evidenceUrl;
    }

    isPending(): boolean {
        return this.status === DISBURSEMENT_STATUS.PENDING;
    }

    isCompleted(): boolean {
        return this.status === DISBURSEMENT_STATUS.COMPLETED;
    }

    isFailed(): boolean {
        return this.status === DISBURSEMENT_STATUS.FAILED;
    }

    isPartial(): boolean {
        return this.status === DISBURSEMENT_STATUS.PARTIAL;
    }

    isProcessing(): boolean {
        return this.status === DISBURSEMENT_STATUS.PROCESSING;
    }

    isCancelled(): boolean {
        return this.status === DISBURSEMENT_STATUS.CANCELLED;
    }

}